export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'Un type de formulaire du même nom existe déjà dans cet établissement'
    }
  }
}
